import { type ApiResponse, ErrorCode } from "@employee-management/common";
import type {
  FieldValues,
  Path,
  UseFormGetFieldState,
  UseFormSetError,
} from "react-hook-form";
import { AxiosError } from "axios";

export const parseValidationErrors = <T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
  getFieldState: UseFormGetFieldState<T>
): boolean => {
  if (!(error instanceof AxiosError)) {
    return false;
  }

  const axiosError = error as AxiosError<ApiResponse>;
  const responseData = axiosError.response?.data;

  if (responseData?.error?.code !== ErrorCode.VALIDATION_ERROR) {
    return false;
  }

  const validationErrors = responseData.error.details?.fields;
  if (!validationErrors) {
    return false;
  }

  let hasProcessedErrors = false;

  Object.entries(validationErrors as Record<string, string[]>).forEach(
    ([field, errors]) => {
      // Check if field exists in the form
      const fieldState = getFieldState(field as Path<T>);
      if (fieldState) {
        errors.forEach((errorMessage) => {
          setError(field as Path<T>, {
            message: errorMessage,
          });
          hasProcessedErrors = true;
        });
      }
    }
  );

  return hasProcessedErrors;
};
